<div class='{{nodeType}} node-level-{{nodeLevel}} node' [ngClass]="{'last-child': isLastChild}" >
  <div class="node-row" [appHover]>
    <div class="product-name">
      <span (click)='onClick()' class='clickable' *ngIf='expandable ; else not_expandable'>
        <rfs2-icon name="plus1" class='expandable' [ngClass]="{'open-button': expanded}"></rfs2-icon>
        <span [ngClass]="{'open-text': expanded}">{{data.product}}</span>
      </span>
      <ng-template #not_expandable>
        <span class='not-expandable'>{{data.product || ''}}</span>
      </ng-template>
    </div>
    <div #data_row class='data-row'>
      <div class='data-field details-button'></div>
      <div class='data-field details-button'></div>
      <div class='data-field aantal'></div>
      <div class='data-field abb'></div>
      <div class='data-field arno'></div>
      <div class='data-field saldo'>
        <span *ngIf="!isBalanceToggle">
          <rfs2-icon name='senses-slot-dicht' size="xs"></rfs2-icon>
        </span>
      </div>
      <div class='data-field bank'></div>
      <div class='data-field specifics'></div>
      <div class='data-field status'></div>
      <div class='data-field relation'></div>
      <div class='data-field expand-all-button'></div>
    </div>
  </div>
</div>
<div [hidden]="!expanded" class='child-nodes'>
  <ng-container #po_node></ng-container>
</div>
